var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Info, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M11.8295 17H13.8295V11H11.8295V17ZM12.8295 9C13.1129 9 13.3504 8.90417 13.542 8.7125C13.7337 8.52083 13.8295 8.28333 13.8295 8C13.8295 7.71667 13.7337 7.47917 13.542 7.2875C13.3504 7.09583 13.1129 7 12.8295 7C12.5462 7 12.3087 7.09583 12.117 7.2875C11.9254 7.47917 11.8295 7.71667 11.8295 8C11.8295 8.28333 11.9254 8.52083 12.117 8.7125C12.3087 8.90417 12.5462 9 12.8295 9ZM12.8295 22C11.4462 22 10.1462 21.7375 8.92952 21.2125C7.71285 20.6875 6.65452 19.975 5.75452 19.075C4.85452 18.175 4.14202 17.1167 3.61702 15.9C3.09202 14.6833 2.82952 13.3833 2.82952 12C2.82952 10.6167 3.09202 9.31667 3.61702 8.1C4.14202 6.88333 4.85452 5.825 5.75452 4.925C6.65452 4.025 7.71285 3.3125 8.92952 2.7875C10.1462 2.2625 11.4462 2 12.8295 2C14.2129 2 15.5129 2.2625 16.7295 2.7875C17.9462 3.3125 19.0045 4.025 19.9045 4.925C20.8045 5.825 21.517 6.88333 22.042 8.1C22.567 9.31667 22.8295 10.6167 22.8295 12C22.8295 13.3833 22.567 14.6833 22.042 15.9C21.517 17.1167 20.8045 18.175 19.9045 19.075C19.0045 19.975 17.9462 20.6875 16.7295 21.2125C15.5129 21.7375 14.2129 22 12.8295 22Z",
    fill: "#707B8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.6ccf24fb45945fe13195cef2542087a6.svg";
export { ForwardRef as ReactComponent };